import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import { LayoutProvider } from '../_template/layout/core/LayoutProvider';
import { LayoutSplashScreen } from '../_template/layout/core/MetronicSplashScreen';
import MasterInit from '../_template/layout/MasterInit';
import { AuthInit } from './routing/AuthInit';

const EntryFrems = (props) => {
    return (
        <Suspense fallback={<LayoutSplashScreen visible={props.visible} />}>
            <LayoutProvider>
                <AuthInit>
                    <Outlet />
                    <MasterInit />
                </AuthInit>
            </LayoutProvider>
        </Suspense>
    )
}

export default EntryFrems;